import MuiPaper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';

import { colors } from '../styles';

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const ContainerDefault = withStyles({
  root: {
    borderRadius: '5px',
    border: `1px solid ${colors.gray.light}`,
    boxShadow: `1px 1px 5px ${colors.shadows.default}`,
    display: 'inline-block',
    outline: 'none',
    boxSizing: 'border-box',
  },
})(MuiPaper);
